import React, { createContext, useContext, useState } from "react";

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
const [verificationId,setVerificationId] = useState('')
const [verificationMail,setVerificationMail] = useState('')
const [changePassId,setChangePassId] = useState('')
const [changePassMail,setChangePassMail] = useState('')
const [reqId,setReqId] = useState('')

    return (
        <UserContext.Provider
            value={{
                verificationMail,
                setVerificationMail,
             verificationId,
                setVerificationId,
                changePassId,
                setChangePassId,
                changePassMail,
                setChangePassMail,
                reqId,
                setReqId
            }}
        >
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("useUser must be used within UserProvider");
    }
    return context;
};
